module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioReady),
      expression: "isAudioReady"
    }],
    staticClass: "lcAudioPlayer nonSelectable"
  }, [_c('mu-card-text', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "width": "410%"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('mu-icon', {
    staticClass: "playButton",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px"
    },
    attrs: {
      "color": "#1692DA",
      "value": _vm.isPlaying ? 'pause_circle_outline' : 'play_circle_outline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.playOrPause()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "playerBar"
  }, [_c('div', [_c('vue-slider', {
    attrs: {
      "bgStyle": _vm.playerSliderOptions.bgStyle,
      "processStyle": _vm.playerSliderOptions.processStyle,
      "sliderStyle": _vm.playerSliderOptions.sliderStyle,
      "height": _vm.playerSliderOptions.height,
      "width": _vm.playerSliderOptions.width,
      "dotSize": _vm.playerSliderOptions.dotSize,
      "tooltip": "false",
      "min": 0,
      "max": _vm.duration,
      "speed": 0
    },
    on: {
      "callback": _vm.durationChanged,
      "drag-start": function($event) {
        return _vm.dragSeekDurationStarted()
      },
      "drag-end": function($event) {
        return _vm.dragSeekDurationEnded()
      }
    },
    model: {
      value: (_vm.currentDuration),
      callback: function($$v) {
        _vm.currentDuration = $$v
      },
      expression: "currentDuration"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "durationStats left"
  }, [_vm._v("\n      " + _vm._s(_vm.currentTime) + "/" + _vm._s(_vm.audioDuration) + "\n    ")]), _vm._v(" "), (_vm.isAudioReady === true) ? _c('div', {
    staticClass: "volume-controls left"
  }, [_c('mu-icon', {
    staticStyle: {
      "float": "left",
      "cursor": "pointer"
    },
    attrs: {
      "color": "#1692DA",
      "value": _vm.audioIcon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.mute()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVolumeControlsVisible === true),
      expression: "isVolumeControlsVisible === true"
    }],
    staticClass: "control desktopOnly"
  }, [_c('vue-slider', {
    attrs: {
      "direction": _vm.volumeSliderOptions.direction,
      "tooltip": "false",
      "min": _vm.volumeSliderOptions.min,
      "max": _vm.volumeSliderOptions.max,
      "interval": _vm.volumeSliderOptions.interval,
      "speed": _vm.volumeSliderOptions.speed,
      "width": _vm.volumeSliderOptions.width,
      "height": _vm.volumeSliderOptions.height
    },
    on: {
      "drag-start": function($event) {
        return _vm.dragVolumeStarted()
      },
      "drag-ended": function($event) {
        return _vm.dragVolumeEnded()
      },
      "callback": _vm.setVolume
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "audioFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.url,
      "preload": "auto",
      "controls": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01721ead","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioPlayer/AudioPlayer.vue
// module id = 3024
// module chunks = 1